
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const DNSManagementPage = lazy(() => import('../pages/dns-management/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/dns-management',
    element: <DNSManagementPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
